import React from 'react';
import PropTypes from 'prop-types';
import {convertPipeToBrTag} from "../../utils";

const ColorInfo = ({
                     name,
                     colorInformation,
                     price,
                     taxPrice,
                   }) => {
  return (
    <div className="ExteriorView__color-info">
      <p className="ExteriorView__color-info__paragraph">{name}</p>
      {(() => {
        if (!colorInformation || colorInformation === '') return null;
        if ((null != price && '0' != price) || (null != taxPrice && '0' != taxPrice)) {
          price = Number(price).toLocaleString();
          taxPrice = Number(taxPrice).toLocaleString();
          let text = colorInformation.replace(/{¥}/g, taxPrice).replace(/{¥¥}/g, price);
          return (
            <p className="ExteriorView__color-info__paragraph2"
               dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text)}}/>
          )
        } else {
          return (
            <div className="ExteriorView__color-info__paragraph2"/>
          )
        }
      })()}
    </div>
  )
};
ColorInfo.propTypes = {
  name: PropTypes.string,
  colorInformation: PropTypes.string,
  price: PropTypes.string,
  taxPrice: PropTypes.string,
};
ColorInfo.defaultProps = {
  name: null,
  colorInformation: null,
  price: null,
  taxPrice: null,
};

export default ColorInfo;



// WEBPACK FOOTER //
// ./src/containers/exterior-view/ColorInfo.jsx